import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { AuthService } from '../../providers/auth.service';
import { AlertService } from '../../providers/alert.service';
import { RechargeService } from '../../services/recharge.service';
import { AppConfig } from '../../app/app.config';

/*
  充值
*/
@Component({
    selector: 'page-rechargewx',
    templateUrl: 'rechargewx.html',
    providers: [
        RechargeService
    ]
})
export class RechargeWx {
    record: any;
    info: any;
    isshowwxsm: boolean = false;
    isshowwxzk: boolean = false;
    isshowysf: boolean = false;
    addtime = "";
    wxzyhk = {
        addtime: '1830',
        bankcode: 'weixinsm',
        realname: '',
        commit: ''
    }
    constructor(
        private navPar: NavParams,
        private viewCtrl: ViewController,
        private alert: AlertService,
        private rechargeSerice: RechargeService,
        private config: AppConfig
    ) {
        this.record = this.navPar.get('param');
        if (this.record.BankImg != "" && this.record.type != "yunshanfu") {
            this.isshowwxsm = true
        } else if (this.record.type == "yunshanfu") {
            this.isshowysf = true;
        } else {
            this.isshowwxzk = true;
        }
        this.wxzyhk.commit == "" ? (this.wxzyhk.commit = AppConfig.User.UserName) : (this.wxzyhk.commit = this.wxzyhk.commit);
    }
    wechatname = "";
    ptname = AppConfig.User.UserName;



    //页面返回
    close() {
        this.viewCtrl.dismiss();
    }
    openNewSpecifiedWindow(windowName) {
        window.open('about:blank', windowName, 'width=700,height=400,menubar=no,scrollbars=no');
    }
    ionViewDidEnter() {
    }
    //联系客服
    //2017-03-03
    openKefu() {
        let connect = this.config.getSysConfig();
        this.config.openUrl(connect.CustomerServiceUrl);
    }
    // 支付宝自动下一步
    zfbrgClick() {
        if (!this.wechatname) {
            this.alert.showAlert('请填写您的微信名字');
            return;
        }
        let param = { recordCode: this.record.RecordCode, wechatname: this.wechatname }
        this.rechargeSerice.updateCommt(param).then(s => {
            if (s.Result) {
                this.alert.showAlert('已通知客服处理，请耐心等待。');
            } else {
                this.alert.showAlert(s.Error);
            }
        });
    }

    // 支付宝自动下一步
    weixinsm() {
        if (!this.addtime) {
            this.alert.showAlert('请输入充值时间');
            return;
        }
        this.rechargeSerice.zfbrgRecharge1(parseFloat(this.record.ChargeMoney), this.addtime, this.record.RecodeID).then(s => {
            if (s.Result) {
                this.alert.showAlert('已通知客服处理，请耐心等待。');
            } else {
                this.alert.showAlert(s.Error);
            }
        });
    }
    // 云闪付
    yunshanfu(recordCode) {
        let pars = { recordCode: recordCode, commit: this.wxzyhk.commit };
        this.rechargeSerice.updateCommt(pars).then(s => {
            if (s.Result) {
                this.alert.showAlert('已通知客服处理，请耐心等待。');
            } else {
                this.alert.showAlert("充值失败，请稍后重试或联系客服处理!");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/recharge/rechargewx.ts